import { DEFAULT_COUNTRY } from "../shared/types";
import { PersonType, SignatoryModel } from "./types";
import { defaultAddress } from "../shared/defaults";

export const emptyPerson: PersonType = {
  nationality: DEFAULT_COUNTRY,
  birthdate: "",
  gender: "",
  firstName: "",
  lastName: "",
  fullStreet: "",
  address: defaultAddress(),
  cybwellId: "",
};

export function defaults(cardholder: PersonType): SignatoryModel {
  return {
    isSameAsCardholder: "yes",
    // max 2 where on index 0 is the first signatory, on index 1 is the second one if it exists
    cardholderSignatories: [cardholder],
    // max 2 where on index 0 is the first signatory, on index 1 is the second one if it exists
    otherSignatories: [emptyPerson],
  };
}
